import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ReceiptsStore, ReceiptsState } from './receipts.store';

@Injectable({ providedIn: 'root' })
export class ReceiptsQuery extends QueryEntity<ReceiptsState> {

  constructor(protected store: ReceiptsStore) {
    super(store);
  }

}
